import axios from './../index'

class dept {

    /**
     * 添加部门
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    static addDept(params) {
        return axios.post(`/app-admin/sys/dept/create`,params)
    }
    /**
     * 部门列表
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    static deptTreeList(params) {
        return axios.get(`/app-admin/sys/dept/tree-list`,{params:params})
    }
    //编辑账号
    static deptEdit(params) {
        return axios.put(`/app-admin/sys/dept/update`,params)
    }

    //树形结果集合
    static deptListTree(params) {
        return axios.get(`/app-admin/sys/dept/list-tree`,{params:params})
    }
    //加顶级树形结果集合
    static topDeptTree(params) {
        return axios.get(`/app-admin/sys/dept/top-dept-tree`,{params:params})
    }

}

export default dept;
